import { Helmet } from 'react-helmet-async';
import CandidateDetailsView from 'src/sections/candidates/view/candidate-view';
// ----------------------------------------------------------------------

export default function CandidateDetails() {
  return (
    <>
      <Helmet>
        <title>Hireintel - Dashboard - Candidate</title>
      </Helmet>

      <CandidateDetailsView/>
    </>
  );
}
